<template>
  <div class="Main">
    <van-nav-bar
      fixed
      :border="false"
      :title="$t('user.menu[23]')"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="PageBox">
      <div class="ScrollBox cert-page">
        <template v-if="certificate">
          <div class="cert-body" v-html="certificate.content" />
        </template>
        <van-empty v-else :description="$t('home.helpCenter.empty')" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SgmCertificateDetail',
  computed: {
    certificate() {
      const raw = this.InitData && this.InitData.sgmCertificate;
      const list = Array.isArray(raw) ? raw : [];
      const first = list[0];
      if (!first || typeof first !== 'object') return null;
      const title = first.title != null ? String(first.title).trim() : '';
      const content = first.content != null ? String(first.content).trim() : '';
      if (!title && !content) return null;
      return first;
    }
  }
};
</script>

<style scoped>
.cert-page {
  padding: 12px 16px 24px;
  box-sizing: border-box;
  overflow-y: auto;
  color: #333;
  background: #f7f8fa;
  min-height: 100%;
}

.cert-body {
  font-size: 14px;
  line-height: 1.65;
  text-align: justify;
  word-break: break-word;
  background: #fff;
  border-radius: 10px;
  padding: 14px 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.cert-body >>> img {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
}

/deep/ .van-nav-bar__content {
  background: linear-gradient(to right, $theme-shallow-color, $theme-color);
  color: #fff;
}
/deep/ .van-nav-bar__title {
  color: #fff;
}
/deep/ .van-nav-bar .van-icon {
  color: #fff !important;
}
</style>
